module.exports = __webpack_public_path__ + "static/media/PacMan.7fc45b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/PacMan.png
// module id = 78
// module chunks = 0